module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/wordpress-cool-mat-week-2.json
// module id = 1833
// module chunks = 214321027229262